import { Component, OnInit, Optional, Inject, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { UpdateSupplierFormService } from 'src/app/services/supplier/update-supplier.service';
import { USStates } from 'src/assets/data/us-states';
import { MexicanStates } from 'src/assets/data/mexican-states';
import { CanadianProvinces } from 'src/assets/data/canadian-provinces';
import { Countries } from 'src/assets/data/countries';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { AddressService } from 'src/app/services/address/address.service';
import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-edit-supplier',
  templateUrl: './edit-supplier.component.html',
  styleUrls: ['./edit-supplier.component.scss']
})
export class EditSupplierComponent implements OnInit {
  supplierDetails: any;
  public updateSupplierForm: FormGroup;
  public states: any[];
  public countries = Countries;
  public zipPattern: any = [ /\d/, /\d/, /\d/, /\d/, /\d/];
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  results: any[];
  hasAutocompleteResults: boolean;
  public urlPath: any;


  @Output()
  confirmationAction = new EventEmitter();

  constructor(
  @Optional()
  @Inject(MAT_DIALOG_DATA)
  public data: any,
  private _updateSupplierFormService: UpdateSupplierFormService,
  private addressService: AddressService,
  private route: ActivatedRoute
) { }

  ngOnInit() {
    this._formPopulateData(this.data.supplierDetails);
    this._initializeUpdateSupplierForm();
    this.states = USStates;
    this.urlPath = this.route.snapshot;
  }

  ngAfterViewInit() {
    this._setupLocationSearch();
  }

  private _initializeUpdateSupplierForm () {
    this.updateSupplierForm = this._updateSupplierFormService.getUpdateSupplierForm(this.supplierDetails);
  }

/**
   * look up location from backend
   */

  private _setupLocationSearch() {
    Observable.fromEvent(document.getElementById('address'), 'input')
      .pipe(
        map((e: KeyboardEvent) => {
          let element = e.target as HTMLInputElement;
          let value = element.value;
          return value;
        }),
        debounceTime(750),
        distinctUntilChanged(),
        switchMap(() => {
          let address = this.updateSupplierForm.value.address;
          let country = this.updateSupplierForm.value.countryCode;
          if (address.length > 3) {
            return this.addressService.search(address, country);
          } else {
            return new Observable(sub => {
              sub.next([]);
              sub.complete();
            });
          }
        })
      )
      .subscribe((data: any) => {
        if (!data) {
          this.results = [];
        } else {
          this.hasAutocompleteResults = true;
          this.results = data;
        }
      });
  }

  fill(location) {
    this.addressService.format(location, this.updateSupplierForm.value.countryCode).then(formattedLoc => {
      let parsedLoc = this.addressService.parseAddress(formattedLoc);
      this.updateSupplierForm.patchValue({
        'address': parsedLoc.Address1,
        'city': parsedLoc.City,
        'state': parsedLoc.State,
        'postalCode': parsedLoc.PostalCode
      });
      this.hasAutocompleteResults = false;
    });
  }

/**
   * populate form with existing Data
   * @param suppler details
   */
  private _formPopulateData(supplierInfo) {
    this.supplierDetails = {
      name: supplierInfo.name,
      locationName: supplierInfo.masterLocation ? supplierInfo.masterLocation.name : null,
      address: supplierInfo.masterLocation ? supplierInfo.masterLocation.address : null,
      city: supplierInfo.masterLocation ? supplierInfo.masterLocation.city : null,
      state: supplierInfo.masterLocation ? supplierInfo.masterLocation.state : null,
      zipCode: supplierInfo.masterLocation ? supplierInfo.masterLocation.postalCode : null,
      country: supplierInfo.masterLocation ? supplierInfo.masterLocation.country : null,
      emailContact : supplierInfo.contacts[0].email,
      phoneContact: supplierInfo.contacts[0].phone,
      nameContact: supplierInfo.contacts[0].name ? supplierInfo.contacts[0].name : null
    };
  }

  /**
   * Called when country value changes
   * @param event Country change
   */

  onCountryChange(event) {
    const value = event.target.value;
    switch (value) {
      case 'USA':
        this.states = USStates;
        this.zipPattern = [ /\d/, /\d/, /\d/, /\d/, /\d/];
        break;
      case 'CAN':
        this.states = CanadianProvinces;
        this.zipPattern = [/[A-Za-z]/, /\d/, /[A-Za-z]/, ' ', /\d/, /[A-Za-z]/, /\d/];
        break;
      case 'MEX':
        this.states = MexicanStates;
        this.zipPattern = [/\d/, /\d/, /\d/, /\d/, /\d/];
      default:
        break;
    }
  }


  Cancel($event) {
    let dialogToClose = {
      sourceComponent : this.data.sourceComponent,
      event: $event
    };
    this.confirmationAction.emit(dialogToClose);
  }

  onSaveSupplier($event) {
    let dialogToClose = {
      sourceComponent : this.data.sourceComponent,
      event: $event,
      supplierUpdate: this.updateSupplierForm.value
    };
    this.confirmationAction.emit(dialogToClose);
  }
}
